import getAuthHost from '@/utils/getAuthHost'

const authServer = getAuthHost()

export const AUTH_API = {
  // ログイン・一時トークンの発行
  login: `${authServer}/api/user/login`,
  // ログイン・アクセストークンの発行
  auth: `${authServer}/api/user/auth`,
  // ユーザー情報取得API
  info: `${authServer}/api/user/info`,
  // reissueKeyを使用したログイン
  getTokenByReissuceKey: `/user/get_token`,
  getTokenByNonce: `${authServer}/api/user/auth`,
  postAccessToken: '/user/set_token/',
  authFirebaseUid: `${authServer}/api/user/uid/auth`,
  relationFirebaseUid: `${authServer}/api/user/uid/relation`,
  deleteFirebaseUid: `${authServer}/api/user/uid/delete`,
  registrationFirebaseUid: `${authServer}/api/user/uid/regist`,
  updSwitchStatus: `${authServer}/api/user/switch`
}

export const USER_API = {
  get: `${authServer}/api/user/info`,
  update: `${authServer}/api/user/info/update`,
  delete: `${authServer}/api/user/delete`
}

export const REGISTRATION_API = {
  provision: `${authServer}/api/user/tempregist`,
  main: `${authServer}/api/user/regist`
}

export const LOGIC_API = {
  result: `/api/logic/result`
}

export const ITEM_API = {
  getItem: '/api/items/getitem/',
  getItems: '/api/items/getitems/',
  getTagItemsAll: '/api/subscription',
  setTagItemHistory: '/api/subscription/history/save',
  setVideoPlayHistory: '/api/subscription/play/save',
  setItemFavorite: '/api/favorite/save',
  getFavHistoryText: '/api/subscription/favorite/text',
  getFavHistoryVideo: '/api/subscription/favorite/video',
  getHistoryList: '/api/subscription/history/list',
  setSeeLater: '/api/subscription/later/save',
  getCategoryItems: '/api/subscription/category',
  getSeeLaterItems: '/api/subscription/later'
}

export const PAYMENT_API = {
  payment: '/payment/complete_api',
  getCredit: '/mypage/get_credit_api',
  updateCredit: '/mypage/change_credit_api'
}

export const PAYMENT_SUBSC_API = {
  paymentSubsc: '/subscription/payment/complete_api',
  getCreditSubsc: '/subscription/get_credit_api',
  updateCreditSubsc: '/subscription/change_credit_api'
}

export const PAYMENT_CHOUN_API = {
  paymentSubsc: '/choundiary/payment/complete_api',
  getCreditSubsc: '/choundiary/get_credit_api',
  updateCreditSubsc: '/choundiary/change_credit_api'
}

export const COMMENT_API = {
  getCommentList: '/api/comments/',
  getTopStarList: '/api/comments/gettopstars'
}

export const SUBSC_API = {
  subscStart: '/api/subscription/join/',
  subscRejoin: '/api/subscription/rejoin/'
}

export const CHOUN_API = {
  subscStart: '/api/choundiary/join/',
  subscRejoin: '/api/choundiary/rejoin/'
}

export const ACADEMY_API = {
  getCredit: '/api/academy/get_credit_api',
  updateCredit: '/api/academy/change_credit_api'
}

export const ULMAR_API = {
  getCredit: '/api/ulmar/get_credit_api',
  updateCredit: '/api/ulmar/change_credit_api'
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/API.js